import { Folder } from "../../redux/interfaces/folder.types.ts";

export const getSubfoldersMapByIdToSlug = (folder: Folder | null) => {
  const subfoldersMapByIdToSlug: any = {};

  if (folder?.subfolders) {
    folder.subfolders.forEach((subfolder: any) => {
      subfoldersMapByIdToSlug[subfolder.id] = subfolder.slug;
    });
  }

  return subfoldersMapByIdToSlug;
};
